module.exports = __webpack_public_path__ + "img/coupon_en.548d3914.png";